import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

/** Status premium pristupa: `{ access, canBuy, subscription | null }`. */
export function usePremiumSubscription(options?: {
  enabled?: boolean;
  /** No error toast: the caller only gates an action on `access`. */
  silent?: boolean;
}) {
  const { queryFn, queryKey } = queryKeys.premium.fetchSubscription;
  return useQuery({
    enabled: options?.enabled,
    meta: options?.silent ? { silent: true } : undefined,
    queryFn,
    queryKey,
  });
}
